export default __webpack_public_path__ + "static/media/apollostack.bf29e599.svg";